import { useEffect } from 'react';

// Locks are reference-counted so a modal opened on top of another modal
// (e.g. the inline vendor form inside Edit PO) does not clear the outer
// modal's lock when it closes — which would unfreeze the background and
// jump the page to the top.
let lockCount = 0;
let savedScrollY = 0;

function applyLock() {
  savedScrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
}

function releaseLock() {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  window.scrollTo(0, savedScrollY);
}

/**
 * Locks body scroll when active, preventing mobile viewport shifting
 * when soft keyboard opens inside modals/overlays.
 */
export default function useBodyScrollLock(isOpen) {
  useEffect(() => {
    if (isOpen) {
      if (lockCount === 0) applyLock();
      lockCount += 1;
      return () => {
        lockCount -= 1;
        if (lockCount === 0) releaseLock();
      };
    }
  }, [isOpen]);
}
